// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3_pe1","question":"Question_question__3_kT6","description":"Question_description__3kk7q"};